import React, { useCallback, useState } from "react";

import { faCaretLeft, faFilter, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/router";
import { toast } from "react-toastify";

import { APP_ROUTES } from "@/constants/routes";
import FilterItem from "@/features/explore/filters/FilterItem";
import SelectedFilterItem from "@/features/explore/filters/SelectedFilterItem";
import { handleAxiosError, handleAxiosSuccess } from "@/helpers/common";
import { getInitialMainFilter, mainFilterJson } from "@/helpers/filters";
import { useFilters } from "@/providers/FiltersProvider";
import { saveFilterSearchService } from "@/services/filterServices";
interface IMainFilters {
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
function MainFilters({ setIsOpen }: IMainFilters) {
    const router = useRouter();
    const { setTempFilters, selectedFilterItem, setSelectedFilterItem, tempFilters, setMainFilters, mainFilters } = useFilters();
    const [isLoading, setIsLoading] = useState(false);

    const handleBack = useCallback(() => {
        setSelectedFilterItem(null);
    }, [setSelectedFilterItem]);

    const handleViewResult = async () => {
        try {
            if (JSON.stringify(tempFilters) === JSON.stringify(getInitialMainFilter())) {
                router.push(`${APP_ROUTES.mainExplore}`);
                setIsOpen(false);
                return;
            }
            setIsLoading(true);
            const res = await saveFilterSearchService(tempFilters);
            // handleAxiosSuccess(res.data.message, toast);
            handleAxiosSuccess("Results updated", toast);
            setMainFilters(tempFilters);
            setSelectedFilterItem(null);
            setIsOpen(false);
            setIsLoading(false);
            router.push(`${APP_ROUTES.mainExplore}/${res.data.data.searchId}`);

            gtag("event", "Filters", { description: "Applied" });

        } catch (error) {
            setIsLoading(false);
            handleAxiosError(error, toast);
        }
    };

    const handleClearFilter = useCallback(() => {
        setTempFilters(getInitialMainFilter());
    }, [setTempFilters]);

    const handleClose = useCallback(() => {
        setIsOpen(false);
        setSelectedFilterItem(null);
        setTempFilters(mainFilters);
    }, [mainFilters, setIsOpen, setSelectedFilterItem, setTempFilters]);

    return (
        <div className='commonDrawer filterDrawer'>
            <div className='commonDrawerHeader'>
                {selectedFilterItem
                    ? <button
                        className='unStyledButton backButton'
                        onClick={handleBack}>
                        <FontAwesomeIcon icon={faCaretLeft} />
                    </button>
                    : <button className='unStyledButton backButton'>
                        <FontAwesomeIcon icon={faFilter} />
                    </button>}
                <span className='commonDrawerTitle'>
                    {
                        selectedFilterItem
                            ? selectedFilterItem.title
                            : "Filter"
                    }
                </span>
                {/* {
                    selectedFilterItem
                    && <div className="filter-tooltip">
                        <FontAwesomeIcon icon={faInfoCircle} id="tooltipText" />
                        <Tooltip
                            anchorId="tooltipText"
                            place="bottom"
                            content={selectedFilterItem.tooltipText}
                            style={{ zIndex: 1000 }}
                            className="filters-tooltip"
                        />
                    </div>
                } */}
                <button className='unStyledButton closeButton'>
                    <FontAwesomeIcon icon={faXmark} onClick={handleClose} />
                </button>
            </div>
            <div className='commonDrawerContent p-0'>
                {

                    selectedFilterItem
                        ? <SelectedFilterItem data={selectedFilterItem} />
                        : mainFilterJson.map((item) => {
                            return (
                                <div key={item.name} className="filterRowWrap">
                                    <div className='filterListHeader'>
                                        <h6>{item.name}</h6>
                                    </div>
                                    <div className='filterListBody'>
                                        {
                                            item.children.map((i, index) => <FilterItem data={i} key={index} />)
                                        }
                                    </div>
                                </div>
                            );
                        })
                }
            </div>
            <div className='commonDrawerFooter'>
                <button
                    className='btn-red-outlined'
                    onClick={handleClearFilter}
                    disabled={isLoading}>Reset </button>
                <button
                    className='btn-blue'
                    onClick={handleViewResult}
                    disabled={isLoading}>
                    {!isLoading && (selectedFilterItem ? "Apply filter" : "View results")}
                    {isLoading && <img src="/images/loading-gif.gif" alt="loader_image" className="inlineLoaderIcon" />}
                </button>
            </div>
        </div>
    );
}

export default MainFilters;
